import React from "react";
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from "react-router-dom";

import { useAuth } from "../hooks/auth";

interface IRouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<IRouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

  if (user && !isPrivate) {
    return <Redirect to="/" />;
  }

  if (!user && isPrivate) {
    return <Redirect to="/sign-in" />;
  }

  return <ReactDOMRoute {...rest} render={() => <Component />} />;
};

export default Route;
